
import { WeatherDialog } from "./dialogs/WeatherDialog";
import { ActivitiesDialog } from "./dialogs/ActivitiesDialog";
import { FoodDialog } from "./dialogs/FoodDialog";
import { LoungeDialog } from "./dialogs/LoungeDialog";
import { CurrencyDialog } from "./dialogs/CurrencyDialog";
import { TaxiDialog } from "./dialogs/TaxiDialog";

interface TripCardDialogsProps {
  destinationName: string;
  showWeather: boolean;
  setShowWeather: (show: boolean) => void;
  weatherData: any;
  showActivities: boolean;
  setShowActivities: (show: boolean) => void;
  activitiesData: any;
  showFood: boolean;
  setShowFood: (show: boolean) => void;
  foodData: any;
  showLounge: boolean;
  setShowLounge: (show: boolean) => void;
  flightDepartureCode?: string;
  showCurrency: boolean;
  setShowCurrency: (show: boolean) => void;
  currencyData: any;
  showTaxi: boolean;
  setShowTaxi: (show: boolean) => void;
  trip: any;
}

const TripCardDialogs = ({
  destinationName,
  showWeather,
  setShowWeather,
  weatherData,
  showActivities,
  setShowActivities,
  activitiesData,
  showFood,
  setShowFood,
  foodData,
  showLounge,
  setShowLounge,
  flightDepartureCode,
  showCurrency,
  setShowCurrency,
  currencyData,
  showTaxi,
  setShowTaxi,
  trip
}: TripCardDialogsProps) => {
  return (
    <>
      <WeatherDialog
        showWeather={showWeather}
        setShowWeather={setShowWeather}
        weatherData={weatherData}
        destinationName={destinationName}
      />

      <ActivitiesDialog
        showActivities={showActivities}
        setShowActivities={setShowActivities}
        activitiesData={activitiesData}
        destinationName={destinationName}
        tripId={trip.id}
      />

      <FoodDialog
        showFood={showFood}
        setShowFood={setShowFood}
        foodData={foodData}
        destinationName={destinationName}
        tripId={trip.id}
      />

      <LoungeDialog
        showLounge={showLounge}
        setShowLounge={setShowLounge}
        flightDepartureCode={flightDepartureCode}
      />

      <CurrencyDialog
        showCurrency={showCurrency}
        setShowCurrency={setShowCurrency}
        currencyData={currencyData}
        destinationName={destinationName}
      />

      <TaxiDialog
        showTaxi={showTaxi}
        setShowTaxi={setShowTaxi}
        destinationName={destinationName}
      />
    </>
  );
};

export default TripCardDialogs;
